import ReactDOM from 'react-dom/client';
import { TenantContext } from '../../../context/tenant-context';
import { TransactionsReport } from './transaction-report';
import { v2Component } from '../../../index';

export function initTransactionsReport() {
  document.getElementsByName('transactions-report').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <TransactionsReport />
            </TenantContext.Provider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
